import { TabVO } from './../../vo/workingzone/tab.vo';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { BasicScenario, TabWrapper, TabCriteria, Tab } from '@wizeoo/akm-message-lib';

/** find sur modèle de vue (physique) */
export class TabCmd extends WizCommand<TabWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  private _basicWrapper: TabWrapper;
  public getBasicWrapper(): TabWrapper {
    if (!this._basicWrapper) {
      this._basicWrapper = new TabWrapper();
      this._basicWrapper.criteria = new TabCriteria();
      this._basicWrapper.criteria.domain = this.model.domainCode;
      this._basicWrapper.scenario = new BasicScenario();
      this._basicWrapper.method = WIZ_COMMAND_METHOD.FIND;
    }
    return this._basicWrapper;
  }

  public find(): TabCmd {
    const wrapper: TabWrapper = this.getBasicWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.TABS_API, wrapper);
    return this;
  }

  // @Override. Alimentation du modèle sur retour de service
  public wizResult() {
    super.wizResult();
    const remoteTabs: Tab[] = this.result.entities as Tab[];
    const resVO = remoteTabs.map((t) => new TabVO(this.model, t));
    this.model.tabsCollection = resVO;
  }
}
